import { Modality, SupportedLanguage } from '@semanticedge/persistence-service-noheaders-client/src'

export enum ProjectViewDialog {
	NONE = 'NONE',
	PROJECT_SETTINGS = 'PROJECT_SETTINGS',
	VIEW_SETTINGS = 'VIEW_SETTINGS',
	WARNINGS = 'WARNINGS',
	ERRORS = 'ERRORS',
	SAVE_CONFIRMATION = 'SAVE_CONFIRMATION',
	CONSTRAINTS = 'CONSTRAINTS',
	OUTPUT_OBJECT = 'OUTPUT_OBJECT_PROMPTS',
	AI_TRANSLATE = 'AI_TRANSLATE',
	SLOT_FILLING = 'SLOT_FILLING',
	EXPERTISE = 'EXPERTISE',
	NODE_SELECTION_ON_EDGE_DROP = 'NODE_SELECTION_ON_EDGE_DROP',
	NEW_ELEMENT = 'NEW_ELEMENT',
	GLOBAL = 'GLOBAL',
	FORM_PREVIEW = 'FORM_PREVIEW',
	TEXT_MODE_EDGES = 'TEXT_MODE_EDGES',
	CLOSE_SIDE_SHEET_CONFIRMATION = 'CLOSE_SIDE_SHEET_CONFIRMATION',
	CREATE_VERSION = 'CREATE_VERSION',
	CREATE_INSTANCE = 'CREATE_INSTANCE',
	COPY_INSTANCE = 'COPY_INSTANCE',
	DELETE_INSTANCE = 'DELETE_INSTANCE',
	EDIT_INSTANCE = 'EDIT_INSTANCE',
	CREATE_LEVER_ITEM = 'CREATE_LEVER_ITEM',
	EDIT_LEVER_ITEM = 'EDIT_LEVER_ITEM',
	DELETE_LEVER_ITEM = 'DELETE_LEVER_ITEM',
	CREATE_OUTPUT_OBJECT_ITEM = 'CREATE_OUTPUT_OBJECT_ITEM',
	EDIT_OUTPUT_OBJECT_ITEM = 'EDIT_OUTPUT_OBJECT_ITEM',
	DELETE_OUTPUT_OBJECT_ITEM = 'DELETE_OUTPUT_OBJECT_ITEM'
}

export enum ProjectSelectionDialog {
	NONE = 'NONE',
	PROJECT_CONFIGURATION = 'PROJECT_CONFIGURATION',
	DELETE_PROJECT_CONFIRMATION = 'DELETE_PROJECT_CONFIRMATION',
	PROJECT_IMPORT = 'PROJECT_IMPORT'
}

export type DialogType = ProjectViewDialog | ProjectSelectionDialog

interface BaseDialog {
	dialogType: DialogType
}

export interface OutputObjectPromptVariantsRequest extends BaseDialog {
	selectedConstraintIds: string
	language: string
	prompts: OutputObjectPrompts
	selectedModality: Modality
}

export interface OutputObjectPromptVariantsResponse extends OutputObjectPromptVariantsRequest {}

type CSV = string | `${string},${string}`
export type BracketedCSV = `[${CSV}]`
export type ConstraintSetIds = BracketedCSV

export type OutputObjectPrompts = Record<
	ConstraintSetIds,
	Record<Modality, Record<SupportedLanguage, string[]>>
>
